/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import SplitType from 'split-type'
import anime from 'animejs';
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import MagnetMouse from 'magnet-mouse';
import AOS from 'aos';
import slick from 'slick-carousel';

import * as ScrollMagic from "scrollmagic"; // Or use scrollmagic-with-ssr to avoid server rendering problems
import { TweenMax, TimelineMax } from "gsap"; // Also works with TweenLite and TimelineLite
import gsap from 'gsap';
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
import Headroom from "headroom.js";

// select your header or whatever element you wish
const header = document.querySelector("header.header");

const headroom = new Headroom(header);
headroom.init();

import Alpine from 'alpinejs'
import App from './alpine/_app.js'
import PostsList from './alpine/_posts-list.js'
import alpineUI from '@alpinejs/ui'
import intersect from '@alpinejs/intersect'
import focus from '@alpinejs/focus'

alpineUI(Alpine)

Alpine.plugin(intersect)
Alpine.plugin(focus)
Alpine.data('App', App)
Alpine.data('PostsList', PostsList)

window.Alpine = Alpine

Alpine.start()

var staff_ajax = require('./staff_ajax')
var insights_ajax = require('./insights_ajax')
var share_functionality = require('./share_functionality')
var jump_to_menu = require('./jump_to_menu')

var capabilities_v2 = require('./capabilities_v2')

function homeBanner() {
  gsap.fromTo('.home-banner--word', {
    yPercent: 50,
    opacity: 0
  }, {
    yPercent: 0,
    opacity: 1,
    duration: 0.5,
    stagger: 0.1,
    delay: 2
  })
}


ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax)

function autoresizeTextArea() {

	$(document).on('input', 'textarea', function () {
        $(this).outerHeight(38).outerHeight(this.scrollHeight) // 38 or '1em' -min-height
    })
}


function contactForm() {
  if ($('.contact-form--selector').length) {
    $('.dynamic-primary-challenge').removeClass('gfield_visibility_hidden')
    $('.dynamic-primary-challenge').addClass('gfield_visibility_visible')

    $('.contact-form--selector li').on('click', function(e) {
      e.preventDefault();
      var $challenge = $(this).find('h4').text();

      $('.dynamic-primary-challenge textarea').val($challenge);

      $('.contact-form--selector').fadeOut(function(e) {
        $('.your-challenge').removeClass('active');
        $('.your-info').addClass('active');
        $('.contact-form--wrapper').fadeIn();
      });
    });
  }
}


function AboutCrewAnimation() {
	if ($('.block.about-crew ').length > 0) {

		var about_scene = $('.about-crew--scene'),
			letter_c = $('.letter_c .about-crew--letter'),
			letter_c_svg = $('.letter_c .about-crew--letter svg'),
			letter_r = $('.letter_r .about-crew--letter'),
			letter_r_svg = $('.letter_r .about-crew--letter svg'),
			letter_e = $('.letter_e .about-crew--letter'),
			letter_e_svg = $('.letter_e .about-crew--letter svg'),
			letter_w = $('.letter_w .about-crew--letter'),
			letter_w_svg = $('.letter_w .about-crew--letter svg');

		var controller = new ScrollMagic.Controller();

		// letter R
		var tween = new TimelineMax();
			tween.to(about_scene, {duration: 250, className:"about-crew--scene about-crew--active c-active"});
			tween.to(about_scene, {duration: 250, className:"about-crew--scene about-crew--active r-active"});
			tween.to(about_scene, {duration: 250, className:"about-crew--scene about-crew--active e-active"});
			tween.to(about_scene, {duration: 250, className:"about-crew--scene about-crew--active w-active"});
			tween.to(about_scene, {duration: 250, className:"about-crew--scene about-crew--active impact-active"});

		// canvas
		var canvas = new ScrollMagic.Scene({
			triggerElement: ".block.about-crew",
			duration: 3000,
			triggerHook: (window.matchMedia('(min-width: 768px)').matches ? 0.2 : 0.4)
		})
		.setPin(".about-crew--scene")
		.setTween(tween)
		.addTo(controller);
	}
}

function workBrowser() {

	if($('.work-browser').length > 0){

		var $bg = $('.work-browser').attr('data-entrancebackground');
		var $txt = $('.work-browser').attr('data-entrancetext');

		// $(window).on("resize", function () {
		// 	var $browserWidth = $('.work-browser .row').css('width');
		// 	$('.work-browser .work-browser--window img').css('maxWidth', $browserWidth);
		// }).resize();

		var controller = new ScrollMagic.Controller();

		$(window).load(function () {

			var $duration = $('.work-browser--window').outerHeight();
			var $browserHeight = $('.work-browser--browser').outerHeight();
			var tweenSize = ($duration - $browserHeight) * -1 ;

				var scene = new ScrollMagic.Scene(
									{
										triggerElement: ".work-browser--browser",
										duration: $duration,
										triggerHook: 0.15
									}
								)
								.setPin(".work-browser--browser")
								.addTo(controller)
								.on('enter', function(e){
									$('.work-browser--browser').addClass('pinned');
								    $('body').attr('data-entrancebg', $bg);
						      		$('body').attr('data-entrancetext', $txt);
								})
								.on('leave', function(e){
									$('.work-browser--browser').removeClass('pinned');
								})
								.setTween(".work-browser--window img", 0.5, {y: tweenSize, ease: "none" })


				//scene.offset(600);
		});

	}

}

function scrollToElement($href, $offset) {

    if ($href.length > 1) {
        $("html, body").animate(
            {
                scrollTop: $($href).offset().top - $offset
            },
            500
        );
    }

}

function bioSlideToggle() {

	$(document).on('click', '.staff--item', function(e) {
		$(this).find('.staff--item_bio').slideToggle();
	});
}

function capabilitiesMenu() {
	var hash = window.location.hash.substr(1);

	if (hash) {

		$('.capabilities--menu li').removeClass('active');
		$('.capabilities--menu li[data-title="' + hash + '"]').addClass('active');

		$('.capabilities--section.active').fadeOut(function() {
			$('.capabilities--section.active').removeClass('active');
			$('#' + hash).addClass('active').fadeIn();
			scrollToElement('#capabilities--section_wrap', 75);

		});

	}

	$('.capabilities--menu li').on('click', function(e) {

		//e.preventDefault();

		if (!$(this).hasClass('active')) {

			var $a_el = $(this).find('a'),
				$a_el_href = $a_el.attr('href'),
				$a_el_title = $a_el.html();

			scrollToElement('#capabilities--section_wrap', 75);

			$('.capabilities--menu li').removeClass('active');
			$(this).addClass('active');

			$('.capabilities--section.active').fadeOut(function() {
				$('.capabilities--section.active').removeClass('active');
				$($a_el_href).addClass('active').fadeIn();
			});
		}


	});
}

function postsSlider() {
	$('.posts-slider--slider').slick({
		vertical: false,
		arrows: false,
		dots: true,
		slidesToShow: 1,
  		slidesToScroll: 1,
  		verticalSwiping: true,
  		autoplay: true,
  		autoplaySpeed: 5000,
  		pauseOnHover: true,
  		fade:true,
  		adaptiveHeight: false,
		customPaging : function(slider, i) {
            return '<div class="slick-button"></div>';
        },
	});
}

function logoBanner() {
	$('.logo-banner--slider').slick({
		vertical: false,
		arrows: false,
    variableWidth: true,
		dots: false,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 4000,
    cssEase: "linear",
    pauseOnHover: false,
	});
}


function initAOS() {
	AOS.init();
}

// function workGrid() {

// 	$( ".work-grid--item" ).mousemove(function(e) {

// 		var x = e.pageX - $(this).offset().left;
// 		var y = e.pageY - $(this).offset().top;

// 		$( this ).find('.work-grid--item_image').css( "clip-path", "circle(104px at " + x + "px " + y + "px)" );

// 	});

// 	$( ".work-grid--item" ).on('mouseenter', function(e) {

// 		var x = e.pageX - $(this).offset().left;
// 		var y = e.pageY - $(this).offset().top;

// 		$('.cursor').addClass('trans-25');
// 		$(this).removeClass('mouse-left');
// 		$(this).addClass('mouse-entered');
// 		$(this).find('.work-grid--item_image').css( "clip-path", "circle(104px at " + x + "px " + y + "px)" );

// 	});

// 	$( ".work-grid--item" ).on('mouseleave', function(event) {
// 		$('.cursor').removeClass('trans-25');
// 		$(this).addClass('mouse-left');
// 		$(this).removeClass('mouse-entered');
// 	});

// }

function magnetMouse() {
	let mm = new MagnetMouse({
	    magnet: {
	  	    position: 'center',
	        element: '.is-style-magnetic-btn .wp-block-button__link',
	        distance: 40
	    },
	    inCallback: function (data) {
		    $('.cursor').addClass('hidden');
		},
		outCallback: function (data) {
		    $('.cursor').removeClass('hidden');
		}
	});

	mm.init();
}

/**
 *  Add shrink class to header on scroll
 */
function addShrinkClassOnScroll() {

    var $body = $("body"),
        $threshold = 65,
        $window = $(window);

    $window.scroll(function() {
		var $scroll_position = $window.scrollTop();
        if ($scroll_position > $threshold) {
            $body.addClass("shrink");
        } else {
            $body.removeClass("shrink");
        }
    });
}

/**
 * Font Awesome
 */

function FontAwesome() {
	// add the imported icons to the library
	library.add(faArrowRight);

	// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
	dom.watch();
}


/**
 * Split Text function
 */

function splitText() {
	let split = new SplitType(document.querySelector('.split-text'), {
	  split: 'words, lines'
	})
}

function workVideo() {
	$('.work-video--video_thumb').on('click', function(e) {
		e.preventDefault();

		var $iframe = $(this).prev(),
			$iframe_src = $iframe.data('src');

		$iframe.attr('src', $iframe_src);

		$(this).fadeOut();

	});
}

function mobileMenuTrigger() {
	$('.header--mobile-trigger').on('click', function(e) {
		$('body').toggleClass('menu-open');
	});
}

/**
 * Init functions
 */
//magnetMouse();

$(document).ready(() => {
	addShrinkClassOnScroll()
	splitText()

	if ( $('body').hasClass('init-home')  ) {
		homeBannerKeywords()
	}
  homeBanner()
	logoBanner()
	FontAwesome()
	initAOS()
	postsSlider()
	// workGrid()
	capabilitiesMenu()
	bioSlideToggle()
	workBrowser()
	contactForm()
	AboutCrewAnimation()
	mobileMenuTrigger()
	autoresizeTextArea()
});
